var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:[{large: _vm.large}, {block: _vm.block}]},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }